<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Payment</span>
        </v-card-title>
        <v-form
          ref="form"
          method="post"
          action="/"
          lazy-validation
          @submit.prevent="savePayment()"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="form.managed_client_id"
                    :items="clients"
                    :loading="isClientsLoading"
                    :search-input.sync="clientSearch"
                    clearable
                    hide-details="auto"
                    item-text="name"
                    item-value="id"
                    hide-no-data
                    label="Managed Client"
                    placeholder="Search client by name"
                    :rules="[
                      v => !!v || 'Managed client is required',
                    ]"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-title>
                          Search for a managed client
                        </v-list-item-title>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="data">
                      {{ data.item.name }} - {{ data.item.account_number }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-avatar class="primary font-weight-light white--text">
                        {{ data.item.name.charAt(0) }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-text="data.item.name"></v-list-item-title>
                        <v-list-item-subtitle v-text="data.item.account_number"></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <small
                    v-show="form.errors.has('managed_client_id')"
                    class="validation-error"
                  >{{ form.errors.get('managed_client_id') }}</small>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.amount"
                    label="Amount"
                    placeholder="Payment amount"
                    type="number"
                    min="0.01"
                    step="0.01"
                    :rules="[
                      v => !!v || 'Amount is required',
                      v => parseFloat(v) >= 0.01 || 'Amount must be at least 0.01',
                    ]"
                    required
                  ></v-text-field>
                  <small
                    v-show="form.errors.has('amount')"
                    class="validation-error"
                  >{{ form.errors.get('amount') }}</small>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.payment_reference"
                    label="Payment Reference (optional)"
                    placeholder="Auto-generated if left blank"
                    maxlength="50"
                  ></v-text-field>
                  <small
                    v-show="form.errors.has('payment_reference')"
                    class="validation-error"
                  >{{ form.errors.get('payment_reference') }}</small>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog()"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              type="submit"
              :loading="form.busy"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Form from 'vform'
import axios from 'axios'
import _ from 'lodash'

export default {
  props: {
    showDialog: {
      type: Boolean,
    },
  },
  data: () => ({
    form: new Form({
      managed_client_id: '',
      amount: '',
      payment_reference: '',
    }),
    clients: [],
    isClientsLoading: false,
    clientSearch: null,
  }),
  watch: {
    clientSearch(value) {
      this.getClients(value)
    },
    showDialog(value) {
      if (value && this.clients.length === 0) {
        this.getClients()
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
      this.$refs.form.reset()
    },
    getClients: _.debounce(function (value) {
      this.isClientsLoading = true
      axios
        .get(`managed-clients`, { params: { search: value || '', search_filter: 'name' } })
        .then(response => {
          this.clients = response.data
          this.isClientsLoading = false
        })
        .catch(error => {
          this.isClientsLoading = false
          this.$notification.error(error.response.data.message)
        })
    }, 500),
    savePayment() {
      const isFormValid = this.$refs.form.validate()
      if (!isFormValid) return

      if (!this.form.payment_reference) {
        this.form.payment_reference = ''
      }

      this.form
        .post('managed-client-payments')
        .then(() => {
          this.$notification.success('Payment added successfully')
          this.$emit('close')
          this.$emit('payment-added')
          this.$refs.form.reset()
        })
        .catch(error => {
          this.$notification.error(error.response.data.message)
        })
    },
  },
}
</script>

<style scoped>
.validation-error {
  color: #ff5252;
  font-size: 12px;
  margin-top: -15px;
  margin-bottom: 10px;
  display: block;
}
</style>
